import Ad from '@/entities/Ad.js';
import api from '@/services/Api';

export default {
  // Every ad affected by a single activity-log entry (adset-level entries can
  // affect several ads). Returns Ad instances shaped exactly like the post ad
  // list, so they can be passed straight to AdDetailsModal.
  getAffectedAds(id) {
    return api().get('/rule-activity-log/' + id + '/ads')
      .then(resp => resp.map(i => new Ad(i)));
  },
};
